import util from "@/common/util";
import { getAnimateStyleMap } from "@/common/utils/animated";

const loftAnimateInit = 'lof-animate-init';




function doObserver(container, config) {
    let {  name, selector, enable,  options } = config;
    if (enable !== false) {
        let elements = selector ? container.querySelectorAll(selector) : [container];
        // Store observers on the element for cleanup
        let observer = util.getObserver(elements, (target) => {
            console.log('getObserver', target);
            // target.classList.add(name)
            if (!target.classList.contains(loftAnimateInit)) {
                return;
            }
            let style = getAnimateStyleMap(config);
            Object.entries(style).forEach(([key, value]) => {
                target.style.setProperty(key, value);
            });
            target.addEventListener('animationend', () => {
                target.classList.remove(name);
                target.classList.remove(loftAnimateInit);
            }, { once: true });
            target.classList.remove(name);
            requestAnimationFrame(() => {
                
                target.classList.add(name);
            });
        }, options || {
            threshold: 0.2,
            //rootMargin: '-30% 0px -30% 0px' 
        });
        container._observerList.push(observer);
    }
}

function doPrepare(container, config) {
    let { name, selector, enable } = config;
    let elements = selector ? container.querySelectorAll(selector) : [container];
    if (enable !== false) {
        elements.forEach(ele => {
            if (util.isSSRClient && isOnView(ele)) {
                // get animation state
                if (isRunningAnimation(ele)) {
                    console.log('animation is running', ele);
                    ele.addEventListener('animationend', () => {
                        ele.classList.remove(name);
                    }, { once: true });
                    return;
                }
                if (ele.classList.contains(name)) {
                    console.log('animation is already running', ele);
                    ele.classList.remove(name);
                    return;
                }
                
            }
            ele.classList.add(loftAnimateInit);
            ele.classList.remove(name);
        });
    } else {
        elements.forEach(ele => {
            ele.classList.remove(loftAnimateInit);
            ele.classList.remove(name);
        });
    }
}

const animated = (container, binding) => {
    if (util.isSSRServer) {  // util.inCms
        return;
    }
    // console.log('------animated-------', binding.value);
    if (container._observerList) {
        container._observerList.forEach(item => {
            item.disconnect();
        });
    }
    container._observerList = [];
    if (util.isArray(binding.value)) {
        binding.value.forEach(config => doObserver(container, config))
    } else {
        doObserver(container, binding.value);
    }
}

const isRunningAnimation = (element) => {
    if (!element) {
        return false;
    }
    if (!element.getAnimations) {
        return false;
    }
    const animations = element.getAnimations();
    if (animations.length > 0) {
        for (const anim of animations) {
            if (anim.playState === 'running') {
                return true;
            }
        }
    } 
    return false;
}

const isOnView = (ele) => {
    const rect = ele.getBoundingClientRect();
    const winHeight = window.innerHeight;
    const eleHeight = rect.height;
    if (eleHeight === 0) {
        return false;
    }
    if (rect.bottom < 0 || rect.top > winHeight) {
        return false;
    }
    return true;
   
}


const prepareAnimation = (container, binding) => {
    if (util.isSSRServer) {
        return;
    }
    let oldValue = binding.oldValue;
    if (oldValue && oldValue !== binding.value) {
        if (util.isArray(oldValue)) {
            oldValue.forEach(config => doPrepare(container, { ...config, enable: false }))
        } else {
            doPrepare(container, { ...oldValue, enable: false });
        }
    }
    if (util.isArray(binding.value)) {
        binding.value.forEach(config => doPrepare(container, config))
    } else {
        doPrepare(container, binding.value);
    }
}

const genSSRClassProps = (config) => {
    let { name, selector, enable } = config;
    if (enable !== false && !selector) {
        return name;
    }
}

/**
 * v-animated="{name: 'fade-in', duration: 500}"
 * v-animated="[
 *    {name: 'fade-in', duration: 500, selector: 'h3', enable: false, option: { rootMargin: '40%' }}, 
 *    {name: 'fade-in', duration: 1000, selector: 'h2'}
 * ]"
 */
export default (Vue) => {
    Vue.directive("animated", {
        updated(el, binding) {
            if (util.inCms) {
                prepareAnimation(el, binding);
                animated(el, binding);
            }
        },
        beforeMount(el, binding) {
            if (util.isSSRClient || util.isSSRServer) {
                return;
            }
            prepareAnimation(el, binding);
        },
        mounted(el, binding) {
            if (util.isSSRClient) {
                prepareAnimation(el, binding);
            }
            animated(el, binding);
        },
        unmounted(el) {
            if (el._observerList) {
                el._observerList.forEach(observer => observer.disconnect()); 
            }
        },
        getSSRProps(binding) {
            if (binding.instance?.platform?.isReallyUser) {
                // server-side implementation:
                // return the props to be rendered.
                // getSSRProps only receives the directive binding.
                let className = '';
                let style = {};
                if (util.isArray(binding.value)) {
                    let classList = [];
                    binding.value.forEach(config => {
                        classList.push(genSSRClassProps(config));
                        style = { ...style, ...getAnimateStyleMap(config) };
                    });
                    className = classList.filter(c => !!c).join(' ');
                } else {
                    className = genSSRClassProps(binding.value);
                    style = getAnimateStyleMap(binding.value);
                }
                return {
                    style: style,
                    class: className
                }
            }
        }
    });
}